import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import Menu from "../Menu";

const UnclaimedMF: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={contentContainerRef}>
      {/* Static Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography variant="h3" fontWeight="bold" letterSpacing={1}>
            Unclaimed Mutual Funds
          </Typography>
        </Box>
      </Box>
  
      {/* Sections Below */}
      <Box sx={{ padding: "20px", backgroundColor: "#f9f9f9", color: "#000" }}>
        <Box
          sx={{
            padding: "20px",
            margin: "20px auto",
            maxWidth: "800px",
          }}
        >
          {/* How to Claim Section */}
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            How to Claim Unclaimed Mutual Funds
          </Typography>
  
          <Typography variant="body1" paragraph>
            To claim unclaimed mutual funds in India, the holder should contact the respective <strong>Fund House</strong> or <strong>Registrar</strong> and provide the following information:
          </Typography>
  
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Your full name</Typography></li>
            <li><Typography variant="body1">Your Permanent Account Number (PAN)</Typography></li>
            <li><Typography variant="body1">Your folio number (if available)</Typography></li>
            <li><Typography variant="body1">Any other relevant details</Typography></li>
          </ul>
  
          <Typography variant="body1" paragraph sx={{ mt: 2 }}>
            You can submit a <strong>redemption request</strong> online, through the fund house’s mobile app, or by visiting a branch office.
          </Typography>
  
          {/* Transmission Section */}
          <Typography variant="h5" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
            Transmission of Mutual Funds
          </Typography>
  
          <Typography variant="body1" paragraph>
            If you are claiming mutual funds after the <strong>death of an investor</strong>, you must:
          </Typography>
  
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Contact the Fund House</Typography></li>
            <li><Typography variant="body1">Send a formal request for the transmission of the mutual fund units</Typography></li>
            <li><Typography variant="body1">Submit all the required documents (such as death certificate, KYC documents, transmission form, etc.)</Typography></li>
            <li><Typography variant="body1">Follow the transmission guidelines provided by the Fund House</Typography></li>
          </ul>
        </Box>
      </Box>
    </div>
  );
};

export default UnclaimedMF;
